<template>
  <div class="create-audio">
    <div class="maker-header">
      <input type="text" class="input-title" v-model="dubbingName" placeholder="请输入配音名称">
      <div class="save-container">
        <button class="save-button" @click="saveDraft" ><svg-icon name="save"></svg-icon>保存草稿</button>
        <button class="export-button" @click="exportAudio"><svg-icon name="mp3"></svg-icon>导出作品</button>
      </div>
    </div>
    <div class="maker-container">
      <div class="maker-left">
        <div class="maker-left-top">
          <div class="top-item" @click="jumpQuality"><svg-icon name="template"></svg-icon>配同款</div>
          <div class="top-item top-item-center">
            <div class="top-item-speaker">
              <SpeakersContainer @showDialog="stopMainAudio"></SpeakersContainer>
            </div>
            <div class="line"></div>
            <div class="top-item-right">
              <span class="param-title">
                语速
              </span>
              <Slider @getValue="(e) => getValue(e, 'voice_speed')" @click="(e) => getValue(e, 'voice_speed')" :min="80" :max="120" :defaultValue="speedDefault" :step="100" :reset="speedResetFlag"></Slider>
            </div>
          </div>
          <div class="top-item">
            <BgmContainer @showDialog="stopMainAudio"></BgmContainer>
          </div>
        </div>
        <div class="dubbing-container">
          <div class="dubbing-content">
            <!-- textarea-插入和停顿 -->
            <div class="dubbing-top">
              <button class="dubbing-button dubbing-button-left" @click="handlePolyphone" id="polyphone-button"><svg-icon name="yin"></svg-icon>发音纠正</button>
              <button class="dubbing-button dubbing-button-right" @click="handlePause" id="pause-button"><svg-icon name="pause"></svg-icon>插入停顿</button>
            </div>
            <textarea name="" class="textarea" cols="30" rows="10" placeholder="请复制或输入正文内容，最多10000字" 
              ref="textarea" @blur="blurTextarea" :maxlength="maxLength"
              v-model="textareaValue"
              ></textarea> 
            <div class="count">{{count}}/{{maxLength}}</div>
            <!-- 底部试听 -->
            <div class="dubbing-bottom">
              <div class="dubbing-button" @click="playButton">
                <SvoiceTooltip :title="audioFlag ? '停止': '试听效果'">
                  <img class="dubbing-play" :src="audioFlag ? stopImage : playImage" alt="">
                </SvoiceTooltip>
              </div>
              <div class="dubbing-process">
                <Slider :max="audioDuration || 100" @getValue="(e) => playSlider(e)" 
                  :defaultValue="audioCurrent" :label="false" :min="0" @changed="changedSlider"
                  @click="changedSlider"
                  >
                  <span class="duration">
                    {{ audioCurrentFormat }}/{{audioDurationFormat}}
                  </span>
                </Slider>
              </div>
              <!-- <svg-icon name="copy_link_blue"></svg-icon>
              试听链接 -->
            </div>
          </div>
        </div>
      </div>
      <div class="maker-right">
        <div class="title">播放参数设置</div>
        <div class="param">
          <span class="param-title">
            主播音量
          </span>
          <Slider @getValue="(e) => getValue(e, 'voice_volume')"  @click="(e) => getValue(e, 'voice_volume')" :defaultValue="rightParams.voice_volume" :reset="rightResetFlag"></Slider>
        </div>
        <div class="param">
          <span class="param-title">
            配乐音量
          </span>
          <Slider @getValue="(e) => getValue(e, 'bgm_volume')"  @click="(e) => getValue(e, 'bgm_volume')"  :defaultValue="rightParams.bgm_volume" :reset="rightResetFlag"></Slider>
        </div>
        <div class="param">
          <span class="param-title">
            配乐播放(秒)后播放人声
          </span>
          <Slider :max="30" @getValue="(e) => getValue(e, 'voice_delay_time')" @click="(e) => getValue(e, 'voice_delay_time')"  :defaultValue="rightParams.voice_delay_time" :reset="rightResetFlag"></Slider>
        </div>
        <div class="param">
          <span class="param-title">
            跳过配乐开头前(秒)
          </span>
          <Slider :max="30" @getValue="(e) => getValue(e, 'bgm_start_time')" @click="(e) => getValue(e, 'bgm_start_time')" :defaultValue="rightParams.bgm_start_time" :reset="rightResetFlag"></Slider>
        </div>
        <div class="param" v-if="voiceLoopMode">
          <span class="param-title">
            文本循环时间间隔(秒)
          </span>
          <Slider :max="30" @getValue="(e) => getValue(e, 'voice_loop_gap')" @click="(e) => getValue(e, 'voice_loop_gap')"  :defaultValue="rightParams.voice_loop_gap" :reset="rightResetFlag"></Slider>
        </div>
        <!-- <div class="checkbox-container">
          <input class="checkbox" type="checkbox" :checked="true"> 高保真音质
        </div> -->
        <div class="switch-group">
          <div class="switch">
            <SvoiceSwitch @switchData="(e) => switchData(e, 'voice_loop_mode')" :defaultValue="rightParams.voice_loop_mode" :reset="rightResetFlag"></SvoiceSwitch>
            <span class="switch-title">人声循环至配乐结束</span>
          </div>
          <div class="switch">
            <SvoiceSwitch @switchData="(e) => switchData(e, 'bgm_volume_down')" :defaultValue="rightParams.bgm_volume_down" :reset="rightResetFlag"></SvoiceSwitch>
            <span class="switch-title">人声播放时配乐音量减小</span>
          </div>
        </div>
        <div class="reset-container">
          <button class="reset-param" @click="resetParams">恢复默认</button>
        </div>
      </div>
    </div>
    <footer class="footer">
      <p>温馨提示：</p>
      <p>1.下单付费后自动去除音频水印，请试听确保作品无误后合成制作。</p>
      <p>2.规范使用标点，比如使用。；！？断句，配音效果更好。</p>
      <p>3.如果多音字发音不对，可以点击发音纠正，指定发音。</p>
      <p>4.如果句中停顿节奏不对，可以点击输入框上方“插入停顿”或   “不要停顿”进行修改。</p>
      <p>5.如果数字朗读不对，可以直接用汉字输入代替数字，如99朗读成九十九，但是想要读成九九，可以直接输入汉字“九九”。</p>
      <p>6.请查看详细使用教程，如有疑问，可咨询客服。</p>
      <p>7.建议您使用：<a class="link" href="https://www.google.cn/chrome/" target="_blank">谷歌、</a>火狐、Safari、360安全、Edge等主流浏览器体验效果最佳。</p>
      
    </footer>
    <OrderDialog v-show="showOrderFlag" :path="$route.path" :orderInfo="orderInfo"></OrderDialog>
    <div class="popover" v-if="popoverList.length">
      <span class="popover-item" id="popover-item"
        @click="handlePopover(item, index)" v-for="item,index in popoverList" :key="index">{{item}}</span>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import SvoiceTooltip from '@/components/svoice-tooltip.vue'
import OrderDialog from 'components/order-dialog'
import Slider from 'components/slider.vue'
import SvoiceSwitch from 'components/svoice-switch.vue'
import BgmContainer from 'components/bgm-container.vue'
import SpeakersContainer from 'components/speakers-container.vue'
import {phoneDict} from 'utils/pyin.js'
import { mixin } from 'utils/audio-mixin.js'
import { payWithFreeDubbings } from 'api/pay.js'
import {
  createDubOrder
} from 'api/order.js'
import {
  remainingAvailableDubbings
} from 'api/users.js'
import {
  uploadDubDraft,
  updateDubDraft
} from 'api/dubbing.js'
import {
  countValidStrLen,
  trimStr
} from 'utils/strconv'
const playImage = require('@/assets/images/play_big.png')
const stopImage = require('@/assets/images/stop_big.png')

export default {
  name: 'CreateAudio',
  props: {
    msg: String
  },
  components: {
    Slider,
    SvoiceSwitch,
    OrderDialog,
    BgmContainer,
    SpeakersContainer,
    SvoiceTooltip
  },
  mixins: [mixin],
  data() {
    return {
      ttsSynLoadingTitle: '',
      popoverList: [],
      popoverIndex: '',
      textareaValue: '',
      count: 0,
      voiceLoopMode: true,
      rightParams: {
        voice_volume: 100,
        bgm_volume: 100,
        voice_delay_time: 3,
        bgm_start_time: 3,
        voice_loop_gap: 5,
        voice_loop_mode: true,
        bgm_volume_down: true
      },
      rightResetFlag: false,
      audioFlag: false,
      oldText: '',
      audioURL: '',
      audioID: '',
      loading: false,
      orderInfo: {},
      audioMarkFlag: true,
      init: true,
      speedDefault: 100,
      speedResetFlag: false,
      dubbingName: '',
      maxLength: 10000, 
      playImage,
      stopImage
    }
  },
  computed: {
    showOrderFlag () {
      return this.$store.state.global.showOrderFlag
    },
    dubbingParams () {
      return this.$store.state.global.dubbingParams
    },
    speakerMap () {
      return this.$store.state.global.speakerMap
    },
    regenerateFlag () {
      return this.$store.state.global.regenerateFlag
    },
    dubbingID () {
      return this.$store.state.global.dubbingID
    },
    token () {
      return this.$store.state.global.token
    },
  },
  watch: {
    textareaValue (val) {
      console.log(val)
      this.count = countValidStrLen(val)
      let dubbingParams = {...this.dubbingParams}
      dubbingParams.text = val
      dubbingParams.text_len = this.count
      if (!this.init) {
        this.$store.dispatch('global/setDubbingParams', dubbingParams)
      }
    },
    dubbingParams (val, oldVal) {
      console.log(val, 'watch dubbingParams')
      if (val.audio_url === oldVal.audio_url && !this.init) {
        this.audioURL = ''
        this.audio.pause()
        this.audioDuration = 0
      }
    },
    regenerateFlag (val, oldVal) {
      if (val!==oldVal && oldVal === true) {
        this.init = false
      }
    }
  },
  created() {
    
  },
  mounted() {
    const that = this
    window.addEventListener('mouseup', function (e) { 
      if (e.target.id !== 'pause-button' && e.target.id !== 'polyphone-button' && e.target.id !== 'popover-item' ) {
        that.selectionEnd = ''
        that.selectionStart = ''
        that.popoverList = []
      }
    });
    if (this.regenerateFlag) {
      this.setParams()
      this.$nextTick(()=> {
        this.$store.dispatch('global/setRegenerateFlag', false)
      })
    } else {
      let dubbingParams = localStorage.getItem("dubbingParams")
      dubbingParams = dubbingParams && JSON.parse(dubbingParams)
      console.log(dubbingParams, 'dubbingParams')
      if (dubbingParams && dubbingParams.text_len && this.token){
        this.$msgBox.showMsgBox({
          title: '',
          content: '检测到您有未保存的内容，是否恢复文章内容?',
          type: 'remind',
          isShowCancelBtn: true,
          isShowConfimrBtn: true,
        }).then(async () => {
          this.$store.dispatch('global/setDubbingParams', dubbingParams)
          this.setParams('reset')
          this.$nextTick(()=> {
            this.init = false
          })
        }).catch(() => {
          this.$store.dispatch('global/setDubbingParams', '')
          this.init = false
        });
      } else {
        this.$store.dispatch('global/setDubbingParams', '')
        this.init = false
      }
    }
  },
  methods: {
    setParams (type) {
      const {audio_url, text, dubbing_name, voice_speed, voice_volume, bgm_volume, voice_delay_time, bgm_start_time, voice_loop_gap, voice_loop_mode, bgm_volume_down} = this.dubbingParams
      this.audioURL = type !== 'reset' ? audio_url : ''
      this.textareaValue = text
      this.oldText = text
      this.audio.src = type !== 'reset' ? audio_url : ''
      this.audio.play()
      this.rightParams = {
        voice_volume: voice_volume * 100,
        bgm_volume: bgm_volume * 100,
        voice_delay_time: voice_delay_time / 1000,
        bgm_start_time: bgm_start_time / 1000,
        voice_loop_gap: voice_loop_gap / 1000,
        voice_loop_mode: voice_loop_mode,
        bgm_volume_down: bgm_volume_down
      }
      console.log(this.rightParams, 'this.rightParams')
      this.speedDefault = voice_speed * 100
      this.rightResetFlag = !this.rightResetFlag
      this.speedResetFlag = !this.speedResetFlag
      this.voiceLoopMode = voice_loop_mode
      this.dubbingName = dubbing_name
    },
    changedSlider (e) {
      console.log(e, 'changedSlider')
      this.audio.currentTime = e
      this.audio.play()
    },
    playSlider (e) {
      console.log(e, 'playSlider')
      this.audio.currentTime = e
      this.audio.pause()
    },
    async createDubOrder (val,total,speaker_id,text_len) {
      this.$showLoading()
      const res = await createDubOrder({
        dubbing_param: this.dubbingParams,
        id: this.dubbingID
      })
      this.$hideLoading()
      console.log('配音制作: 订单详情', res.data)
      const {fee, dubbing_param, trade_no} = res.data
      this.$msgBox.showMsgBox({
        title: '配音作品',
        textList: [{
          name: '作品名称',
          value: val,
        },{
          name: '配音主播',
          value: this.speakerMap[speaker_id].name,
        },{
          name: '作品字数',
          value: text_len + '字',
        },],
        textListButton: `剩余可用${total}条`
      }).then(async () => {
        if (total > 0) {
          this.payWithFreeDubbings(trade_no)
        } else {
          this.$msgBox.showMsgBox({
            title: '您的可用条数不足',
            buttonList: [{
              name: '购买配音包',
              type: 'bag',
              class: 'button-error'
            },{
              name: '支付单条配音',
              type: 'single',
              class: 'button-primary'
            }]
          }).then(async (type) => {
            if (type === 'bag') {
              this.$router.push({path: '/personal/vip'});
              this.$store.dispatch('global/setBagFlag', true)
            } else if (type === 'single') {
              this.orderInfo = {
                fee: fee/100,
                dubbing_name: dubbing_param.dubbing_name,
                speaker_name: this.speakerMap[dubbing_param.speaker_id].name,
                text_len: dubbing_param.text_len,
                trade_no
              }
              this.showOrderDialog()
            }
          }).catch(() => {
            // ...
            console.log('catch');
          });
        }
      }).catch(() => {
        // ...
        console.log('catch');
      });
    },
    async payWithFreeDubbings (trade_no) {
      const free = await payWithFreeDubbings({ trade_no})
      if (free.code !== 0) {
        return
      }
      localStorage.setItem('dubbingParams', '')
      this.$store.dispatch('global/setUserInfo')
      this.$msgBox.showMsgBox({
        type: 'success',
        title: '',
        content: '保存成功，',
        linked: {
          name: '查看我的作品',
          url: '/maker/audio'
        },
      }).then(async (val) => {
        console.log(val, 'then');
        this.$router.push(val)
      }).catch(() => {
        // ...
        console.log('catch');
      });
    },
    handlePopover (item, index) {
      this.popoverIndex = index
      console.log(this.textareaValue)
      console.log(this.selectionEnd)
      if (this.popoverType === 'pause') {
        const newItem = item === '无停顿' ? '0.0秒' : item
        let start = this.textareaValue.substring(0, this.selectionEnd)
        const reg = /[[0-9]+\.[0-9]+秒]$/
        console.log(start, start.match(reg))
        if (start && reg.test(start)) {
          start = start.replace(/[[0-9]+\.[0-9]+秒]$/, '') 
        }
        const middle = `[${newItem}]`
        const regEnd = /^[[0-9]+\.[0-9]+秒]/
        let end = this.textareaValue.substring(this.selectionEnd, this.textareaValue.length)
         if (end && regEnd.test(end)) {
          end = end.replace(/^[[0-9]+\.[0-9]+秒]/, '')
        }
        console.log(start,middle,end)
        this.textareaValue = start + middle + end
      }
      if (this.popoverType === 'polyphone') {
        const start = this.textareaValue.substring(0, this.selectionEnd)
        const middle = `[=${item}]`
        const reg = /^[=[a-z]+[1-5]]/
        let end = this.textareaValue.substring(this.selectionEnd, this.textareaValue.length)
        console.log(start,middle,end)
        if (end && reg.test(end)) {
          end = end.replace(/^[=[a-z]+[1-5]]/, '')
        }
        this.textareaValue = start + middle + end
      }
      this.popoverList = []
      this.selectionEnd = ''
      this.selectionStart = ''
    },
    switchData (flag, type) {
      if (this.init) {
        return
      }
      console.log(flag, type, 'switchData')
      if (type === 'voice_loop_mode') {
        this.voiceLoopMode = flag
      }
      let dubbingParams = {...this.dubbingParams}
      dubbingParams[type] = flag
      this.$store.dispatch('global/setDubbingParams', dubbingParams)
    },
    jumpQuality () {
      this.$router.push({path: '/maker/template'});
    },
    saveDraft () {
      if (!this.validTextareaValue()) {
        return
      }
      if (!this.audioURL) {
        this.$toast('请先播放试听')
        return
      }
      
      const dubDraftObj = {
        dubbing_type: 1,
        dubbing_param: {...this.dubbingParams, dubbing_name: this.dubbingName, audio_url: ''},
        id: this.dubbingID
      }
      if (this.dubbingID && this.dubbingID.length > 0) {
        updateDubDraft(dubDraftObj).then(res => {
          if (res.data.id) {
            this.$toast('保存成功')
            localStorage.setItem('dubbingParams', '')
          }
        })
      } else { // 上传草稿
        uploadDubDraft(dubDraftObj).then(res => {
          if (res.data.id) {
            this.$toast('保存成功')
            localStorage.setItem('dubbingParams', '')
          }
        })
      }
    },
    exportAudio() {
      if (!this.validTextareaValue()) {
        return
      }
      if (!this.audioURL) {
        this.$toast('请先播放试听')
        return
      }
      this.$msgBox.showMsgBox({
        title: '温馨提示：导出后无法再修改音频内容，',
        content: '确定要保存该作品吗？',
        type: 'remind',
        isShowCancelBtn: true,
        isShowConfimrBtn: true,
      }).then(async () => {
        const remainingAvailable = await remainingAvailableDubbings()
        const { dubbing_package_rest_dubbings, common_free_dubbings, vip_mouthly_rest_dubbings } = remainingAvailable.data
        const total = common_free_dubbings + vip_mouthly_rest_dubbings + dubbing_package_rest_dubbings
        const { text, text_len, speaker_id } = this.dubbingParams
        this.$msgBox.showMsgBox({
          title: '作品名称',
          content: '',
          inputValue: this.dubbingName || text.substring(0, 10),
          isShowInput: true,
          isShowCancelBtn: true,
          isShowConfimrBtn: true,
        }).then(async (val) => {
          console.log(val, 'then');
          let dubbingParams = {...this.dubbingParams}
          dubbingParams.dubbing_name = val
          this.$store.dispatch('global/setDubbingParams', dubbingParams)
          this.createDubOrder(val,total,speaker_id,text_len)
          
        }).catch(() => {
          // ...
          console.log('catch');
        });
      }).catch(() => {
        // ...
        console.log('catch');
      });
    },
    showOrderDialog() {
      this.$store.dispatch('global/setOrderFlag', true)
    },
    getMousePos(event) {
      var e = event || window.event;
      var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
      var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      var x = e.pageX || e.clientX + scrollX;
      var y = e.pageY || e.clientY + scrollY;
      return {x, y}
    },
    blurTextarea (e) {
      const {selectionStart, selectionEnd} = e.target
      console.log(selectionStart, selectionEnd, 'blurTextarea')
      this.selectionStart = selectionStart
      this.selectionEnd = selectionEnd
      this.selectionText = e.target.value.substring(selectionStart, selectionEnd)
    },
    selectSomeText(obj, start, end) {
      obj.selectionStart = start;
      var sel_end = end == undefined ? start : end;
      obj.selectionEnd = Math.min(sel_end, obj.value.length);
      obj.focus();
    },
    handlePolyphone () {
      if (this.selectionEnd - this.selectionStart !== 1 || this.selectionStart === '') {
        this.$toast('请滑选单个字')
        return
      }
      this.selectSomeText(this.$refs.textarea, this.selectionStart, this.selectionEnd)
      console.log(this.selectionText, 'this.selectionText')
      const polyphoneList = phoneDict[this.selectionText]
      if (!polyphoneList) {
        this.$toast('不是多音字')
        return
      }
      this.popoverList = polyphoneList
      console.log(polyphoneList, 'polyphoneList')
      this.popoverType = 'polyphone'
    },
    handlePause () {
      if (!this.validTextareaValue()) {
        return
      }
      console.log(this.selectionStart, this.selectionEnd, 'handlePause')
      if (this.selectionEnd !== this.selectionStart || this.selectionStart === '') {
        this.$toast('请点击需要停顿处，设置插入停顿')
        return
      }
      console.log(this.selectionStart, this.selectionEnd, 'handlePause')
      this.selectSomeText(this.$refs.textarea, this.selectionStart, this.selectionEnd)
      this.popoverList = ['无停顿', '0.3秒', '0.6秒', '0.9秒']
      this.popoverType = 'pause'
    },
    getValue (value, type) {
      if (this.init) {
        return
      }
      console.log(value, type)
      let dubbingParams = {...this.dubbingParams}
      if (type === 'voice_volume' || type === 'bgm_volume') {
        console.log(value, parseFloat(value) / 100)
        dubbingParams[type] = parseFloat(value) / 100 
      } else if (type === 'bgm_start_time' || type === 'voice_delay_time' || type === 'voice_loop_gap') {
        dubbingParams[type] = parseFloat(value) * 1000
      } else {
        dubbingParams[type] = parseFloat(value)
      }
      this.$store.dispatch('global/setDubbingParams', dubbingParams)
      console.log(value, type, 'getValue')
    },
    resetParams () {
      const initParams = {
        voice_volume: 1,
        bgm_volume: 1,
        voice_delay_time: 3000,
        bgm_start_time: 3000,
        voice_loop_gap: 5000,
        voice_loop_mode: true,
        bgm_volume_down: true
      }
      this.rightParams = {
        voice_volume: 100,
        bgm_volume: 100,
        voice_delay_time: 3,
        bgm_start_time: 3,
        voice_loop_gap: 5,
        voice_loop_mode: true,
        bgm_volume_down: true
      }
      this.rightResetFlag = !this.rightResetFlag
      let dubbingParams = {...this.dubbingParams, ...initParams}
      this.$store.dispatch('global/setDubbingParams', dubbingParams)
    },
    validTextareaValue () {
      if (!trimStr(this.textareaValue)) {
        this.$toast('请您先输入配音内容！')
        return false
      }
      return true
    },
    playButton () {
      // 先判断URL是否存在，如果不存在，则进行合成
      if (!this.audioURL) {
        console.log('配音制作: AUDIO audioCtlHandler audio url 不存在，重新合成')
        this.ttsSyn()
        return
      }
      if (this.audioFlag === true) {
        this.audio.pause()
        return
      }
      console.log('配音制作: AUDIO audioCtlHandler audio url 存在，处理逻辑')
      if (this.oldText !== this.textareaValue) {
        this.audio.pause()
        this.ttsSyn()
      } else { // 文本未发生改变：重新播放
        this.audio.play()
      }
    },
    ttsSyn () {
      if (!this.validTextareaValue()) {
        return
      }
      // 制作开始弹框
      this.$showLoading('开始制作音频')
      this.loading = true
      // 清空历史ws返回的音频id
      this.audioID = ''

      const base = location.origin
      console.log(base, process.env.VUE_APP_WS_API)
      if (this.socket) {
        this.socket.close()
      }
      this.socket = new WebSocket(process.env.VUE_APP_WS_API); 
      if (!this.socket) {
        console.log('您的浏览器不支持websocket协议！'); //不进来这个表示浏览器支持WebSocket
      }
      this.socket.onopen = () => {
        console.log('websocket已链接.', this.dubbingParams);
        // const param = {"speaker_id":1,"text":"21","text_len":1,"voice_volume":1,"voice_speed":1,"voice_delay_time":3000,"voice_loop_gap":5000,"voice_loop_mode":true,"bgm_name":"","bgm_volume":1,"bgm_start_time":3000,"bgm_volume_down":true,"sample_rate":24000,"codec":"pcm"}
        this.socket.send(JSON.stringify(this.dubbingParams)); // 向后端发送数据
      };
      this.socket.onmessage = (res) => {
        console.log('e就是返回的数据');
        const response = res.data
        if (response === 'finish') {
          // 判断audioID是否生成
          if (this.audioID.length === 0) {
            this.$showLoading('网络错误，请重试')
            this.audioURL = ''
            return
          }
          // 关闭socket
          this.socket.close()
          // 音频URL
          const audioURL = base + process.env.VUE_APP_BASE_API + '/get_cached_audio/' + this.audioID // 构建音频地址
          this.oldText = this.textareaValue
          this.audioURL = audioURL
          this.audio.src = audioURL
          let dubbingParams = {...this.dubbingParams}
          dubbingParams.audio_url = audioURL
          this.$store.dispatch('global/setDubbingParams', dubbingParams)
          console.log('配音制作: tts合成获取 audioURL: ', this.audioURL)
          this.audio.play()
          this.$hideLoading()
        } else if (/^options:/.test(response)) {
          this.$showLoading(response.replace(/(options:)(.*)/gi, '$2'))
        } else if (/^audio:/.test(response)) {
          this.audioID = response.replace(/(audio:)(.*)/gi, '$2')
          // console.log(baseCfg.baseUrl, dubbingCfg.audioResURL)
          const audioURL = base + process.env.VUE_APP_BASE_API + '/get_cached_audio/' + this.audioID // 构建音频地址
          console.log(audioURL, 'audioURL')
        } else {
          this.$showLoading('网络错误，请重试')
        }
      };
      this.socket.onclose = () => {
        console.log('websocket连接已关闭...');
        // 如果没有顺利合成
        if (this.audioID.length === 0) {
          this.audioURL = ''
        }
        this.$hideLoading(1500)
      };
      this.socket.onerror = (res) => {
        console.log('websocket连接已关闭...', res);
        this.$showLoading('网络错误，请重试')
        if (this.audioID.length === 0) {
          this.audioURL = ''
        } 
        this.$hideLoading(1500)
      }
    },
    stopMainAudio () {
      this.audio.pause()
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    this.$store.dispatch('global/setDubbingID', '')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-audio {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  .maker-header {
    display: flex;
    justify-content: space-between;
    .save-container {
      display: flex;
      button {
        width: 120px;
        height: 40px;
        border-radius: 4px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .save-button {
        background: #FBFBFB;
        border: 1px solid #EEEEEE;
        color: #999999;
        margin-right: 20px;
      }
      .export-button {
        background: #4E6EFF;
        color: #FFFFFF;
      }
      .svg-icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
    }
    .input-title {
      border: none;
      font-size: 16px;
      color: #555;
      outline: none;
      height: 40px;
      width: 100%;
      padding-left: 2px;
    }
  }
  .maker-container {
    display: flex;
    padding-top: 10px;
    box-sizing: border-box;
    .maker-left {
      flex: 1;
      position: relative;
      .maker-left-top {
        display: flex;
        position: absolute;
        top: 0;
        width: 100%;
        .top-item {
          height: 70px;
          background: #FBFBFB;
          border: 1px solid #EEEEEE;
          border-radius: 4px;
          display: flex;
          align-items: center;
          margin-right: 10px;
          box-sizing: border-box;
          position: relative;
          &.top-item-center {
            flex: 1;
            .top-item-speaker {
              flex: 1;
              min-width: 220px;
            }
            .line {
              width: 1px;
              height: 37px;
              background: #EEEEEE;
            }
            .top-item-right {
              padding: 0 20px;
              width: 220px;
              box-sizing: border-box;
              .param-title {
                margin-bottom: 8px;
                display: inline-block;
              }
            }
          }
          &:first-child {
            width: 140px;
            justify-content: center;
            cursor: pointer;
            .svg-icon--template {
              width: 40px;
              height: 40px;
              margin-right: 15px;
            }
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .dubbing-container {
        padding-top: 80px;
        box-sizing: border-box;
        overflow: hidden;
        .dubbing-content {
          border: 1px solid #EEEEEE;
          height: 500px;
          padding: 60px 20px 80px 20px;
          box-sizing: border-box;
        }
        .dubbing-top {
          display: flex;
          position: absolute;
          left: 20px;
          top: 105px;
          .dubbing-button-left {
            background-color: #F3FDFB;
            margin-right: 20px;
            .svg-icon {
              width: 21px;
              height: 17px;
            }
          }
          .dubbing-button-right {
            background-color: #FFF9EF;
            .svg-icon {
              width: 17px;
              height: 17px;
            }
          }
          .dubbing-button {
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            color: #6D7278;
            .svg-icon {
              margin-right: 8px;
            }
          }
        }
        .textarea {
          display: block;
          width: 100%;
          border: none;
          box-sizing: border-box;
          padding: 0;
          outline: none;
          resize:none;
          font-size: 16px;
          color: #555;
          height: 100%;
        }
        .count {
          color: #999999;
          text-align: right;
          position: absolute;
          bottom: 60px;
          right: 29px;
        }
        .dubbing-bottom {
          border-top: 1px solid #EEEEEE;
          height: 56px;
          align-items: center;
          display: flex;
          align-items: center;
          color: #555555;
          position: absolute;
          bottom: 1px;
          width: 100%;
          left: 0;
          .dubbing-button {
            margin: 0 20px;
            .dubbing-play {
              width: 40px;
              height: 40px;
              cursor: pointer;
            }
          }
          .dubbing-process {
            width: 350px;
          }
          .duration {
            margin-left: 10px;
          }
          .svg-icon--copy_link_blue {
            margin: 0 5px 0 60px;
            width: 14px;
            height: 14px;
          }
        }
      }
    }
    .maker-right {
      width: 260px;
      padding: 25px 20px;
      box-sizing: border-box;
      background: #FBFBFB;
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      margin-left: 10px;
      color: #555555;
      font-size: 14px;
      .title {
        font-size: 14px;
        color: #999999;
        text-align: center;
      }
      .param {
        margin-top: 20px;
        .param-title {
          margin-bottom: 8px;
          display: inline-block;
        }
      }
      .checkbox-container {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .checkbox {
          margin-right: 10px;
        }
      }
      .switch-group {
        margin: 30px 0;
        .switch {
          display: flex;
          align-items: center;
          margin-top: 15px;
          .switch-title {
            margin-left: 6px;
          }
        }
      }
      .reset-container {
        text-align: center;
        .reset-param {
          width: 100px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #999999;
          font-size: 14px;
          color: #999999;
          margin: 0 auto;
        }
      }
    }
  }
  .footer {
    font-size: 12px;
    color: #999999;
    line-height: 20px;
    position: relative;
    margin-top: 25px;
    .link {
      color: #4E6EFF;
      text-decoration: none;
    }
  }
  .popover {
    padding: 15px;
    background: #FFFFFF;
    box-shadow: 10px 10px 9px 0px rgba(204, 204, 204, 0.6);
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    position: absolute;
    top: 200px;
    left: 190px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .popover-item {
      height: 30px;
      padding: 0 15px;
      line-height: 30px;
      background: #F5F5F5;
      border-radius: 4px;
      display: inline-block;
      cursor: pointer;
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        background: #4E6EFF;
        color: #fff;
      }
    }
  }
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #CCCCCC;
  font-size: 16px;
}
</style>
